// extracted by mini-css-extract-plugin
module.exports = {"ctn":"Panel_ctn__2le_s","divScroll":"Panel_divScroll__3oF7l"};